__webpack_require__.p = "https://dokumentation.allessafe.de/";